// =================   Profil + Lista anunturi =================
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { RiLogoutBoxLine } from "react-icons/ri";

export default function Cont() {
  const { user, logout } = useAuth();

  if (!user) return <Navigate to="/" />;

  return (
    <div className="cont-page">
      <div className="cont-header">
        <img
          src={user.user_metadata?.avatar_url}
          alt="avatar"
          className="cont-avatar"
        />
        <div>
          <h2>{user.user_metadata?.full_name}</h2>
          <p>{user.email}</p>
        </div>
        <button onClick={logout} className="btn-logout">
          <RiLogoutBoxLine /> Ieși din cont
        </button>
      </div>

      <div className="cont-anunturi">
        <h3>Anunțurile mele</h3>
        <p>Nu ai niciun anunț încă.</p>
      </div>
    </div>
  );
}